@use '@/scss/underscore' as _;

.app {
  position: absolute;
  inset: 0;
}
